module.exports = __webpack_public_path__ + "img/CN_抖音.532de7f3.jpg";